<template>
  <div :class="classObj" class="app-wrapper">
    <!-- <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" /> -->
    <!-- <sidebar class="sidebar-container" /> -->
    <div class="main-container">
      <div v-if="!isMapPage && !isLogin" :class="{ 'fixed-header': fixedHeader }">
        <div class="header-box">
          <div class="cover-box"></div>
          <navbar />
        </div>
      </div>
      <div v-if="isMapPage" :class="{ 'p1mapp': true }">

      </div>

      <app-main />

      <!-- 主页 -->
      <div v-show="showBottom && !isMapPage&&isHomePage"
        class="home-container background-img4 animate__animated animate__zoomIn" :class="`footer-${acctiveParkId}`">
        <div class="footer-box">
          <p class="footer-title top">
              <span style="display: inline-block;">相关链接：
                <a href="http://lqwl.cesp.cn" target="_blank">垃圾分类平台</a>
                <a href="https://edu2.cesp.cn" target="_blank" style="margin-left: 6px">生态环境教育平台</a>
                <a href="https://jksy.cesp.cn" target="_blank" style="margin-left: 6px">生态环境健康素养</a>
                <a href="https://hsvr.cesp.cn" target="_blank" style="margin-left: 6px">红色VR教育平台</a>
              </span>
          </p>
          <p class="footer-title top">
            <span style="display: inline-block; margin-right: 5px">版权所有：中国环境出版集团有限公司</span>
            <span style="display: inline-block; margin-left: 5px">技术支持：中国地图出版社集团有限公司</span>
          </p>
          <p class="footer-title">
                            <span>审图号：GS京（2025）1826号&nbsp;&nbsp;&nbsp;</span>
                            <span>京ICP备：14057358号-1&nbsp;&nbsp;&nbsp;</span>
                            <span>京公网安备：11010102002236号&nbsp;&nbsp;&nbsp;</span>
          </p>
          <p class="footer-title">联系电话: 010-1234567890</p>
        </div>
      </div>


      <!-- 非主页 -->
      <div v-show="showBottom && !isMapPage && !isHomePage"
        class="home-container background-img4-1 animate__animated animate__zoomIn" :class="`footer-${acctiveParkId}`">
        <div class="footer-box">
          <p class="footer-title top">
              <span style="display: inline-block;">相关链接：
                <a href="http://lqwl.cesp.cn" target="_blank">垃圾分类平台</a>
                <a href="https://edu2.cesp.cn" target="_blank" style="margin-left: 6px">生态环境教育平台</a>
                <a href="https://jksy.cesp.cn" target="_blank" style="margin-left: 6px">生态环境健康素养</a>
                <a href="https://hsvr.cesp.cn" target="_blank" style="margin-left: 6px">红色VR教育平台</a>
              </span>
          </p>
          <p class="footer-title top">
            <span style="display: inline-block; margin-right: 5px">版权所有：中国环境出版集团有限公司</span>
            <span style="display: inline-block; margin-left: 5px">技术支持：中国地图出版社集团有限公司</span>
          </p>
          <p class="footer-title">
                            <span>审图号：GS京（2025）1826号&nbsp;&nbsp;&nbsp;</span>
                            <span>京ICP备：14057358号-1&nbsp;&nbsp;&nbsp;</span>
                            <span>京公网安备：11010102002236号&nbsp;&nbsp;&nbsp;</span>
          </p>
          <p class="footer-title">联系电话: 010-1234567890</p>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import { Navbar, AppMain } from "./components";
// import ResizeMixin from './mixin/ResizeHandler'
const whiteList = ["/map", "/loginIndex", "/communityIndex"];
export default {
  name: "Layout",
  components: {
    Navbar,
    AppMain,
  },
  //   mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
    isMapPage() {
      return this.$route.path.startsWith("/map");
    },
    isHomePage() {
      return this.$route.path.startsWith("/homePage");
    },
    isLogin() {
      return this.$route.path.startsWith("/loginIndex");
    },
    showBottom() {
      return !whiteList.some((item) => item === this.$route.path);
    },
    acctiveParkId() {
      return this.$store.state.user.activeParkId;
    },
  },
  watch: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
    handlerClick() {
      window.open("http://116.196.71.73/console", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 12;
  // width: calc(100% - #{$sideBarWidth});
  width: 100%;
  transition: width 0.28s;
  // background-color: #208060;
  // background: url("@/assets/header/header-banner.png") no-repeat center;
  // background-size: 100% 100%;
  .header-box {
    position: relative;
    .cover-box {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #14663d;
      opacity: 0.7;
      z-index: 2;
    }
  }
}

.hideSidebar .fixed-header {
  // width: calc(100% - 54px)
}

.mobile .fixed-header {
  width: 100%;
}

.home-container {
  &.footer-1001 {
    background: url("@/assets/layout/footer-1001.png") no-repeat center;
    background-size: 100% 100%;
  }
  &.footer-1002 {
    background: url("@/assets/layout/footer-1002.png") no-repeat center;
    background-size: 100% 100%;
  }
  &.footer-1003 {
    background: url("@/assets/layout/footer-1003.png") no-repeat center;
    background-size: 100% 100%;
  }
  &.footer-1004 {
    background: url("@/assets/layout/footer-default.png") no-repeat center;
    background-size: 100% 100%;
  }
  &.footer-1005 {
    background: url("@/assets/layout/footer-default.png") no-repeat center;
    background-size: 100% 100%;
  }
  &.footer-1006 {
    background: url("@/assets/layout/footer-default.png") no-repeat center;
    background-size: 100% 100%;
  }
  &.footer-1007 {
    background: url("@/assets/layout/footer-default.png") no-repeat center;
    background-size: 100% 100%;
  }
  &.footer-1008 {
    background: url("@/assets/layout/footer-1008.png") no-repeat center;
    background-size: 100% 100%;
  }
  &.footer-1009 {
    background: url("@/assets/layout/footer-1009.png") no-repeat center;
    background-size: 100% 100%;
  }
  &.footer-1010 {
    background: url("@/assets/layout/footer-default.png") no-repeat center;
    background-size: 100% 100%;
  }

  &.background-img4 {
    height: 360px;
    color: #fff;
    text-align: left;
    background-color: #f4f2e8;
  }

        &.background-img4-1 {
          height: 360px;
          color: #fff;
          text-align: left;
          background-color: #f5f3e1;
        }

  .footer-box {
    height: 120px;
    width: 100%;
    background: #1b7b5bba;
    position: absolute;
    bottom: 0;
    padding-top: 15px;

    .footer-title {
      text-align: center;
      font-size: 12px;
      font-family: MicrosoftYaHei, PingFangSC;
      font-weight: normal;
      line-height: 1.2;
    }
  }

  ul {
    margin-top: 76px;

    .title {
      margin-top: 0;
    }
  }

  li {
    list-style: none;
    cursor: pointer;
    margin-bottom: 10px;
  }
}
@media screen and (min-width: 1920px) {
  .home-container {
    &.background-img4 {
      .footer-box {
        font-size: 16px !important;
        font-family: SourceHanSerifCN-Regular !important;
        .footer-title {
          font-size: 16px !important;
          font-family: SourceHanSerifCN-Regular !important;
          &.top {
            span {
              margin: 0 20px !important;
            }
          }
        }
      }
    }
  }
}
</style>
